import { media, MediaEventType } from '../../webrtc/media';
import { session } from '../../webrtc/session';

type PublisherVideoStats = {
  publisherVideoDisabledDueToQuality: number;
  publisherVideoDisabledWarningDueToQuality: number;
};

// Record<sessionId, { publisherVideoDisabledDueToQuality: 0, publisherVideoDisabledWarningDueToQuality: 2 }>
export const publisherVideoStats: Record<string, PublisherVideoStats> = {};

const getOrInitStats = (sessionId: string): PublisherVideoStats => {
  if (!publisherVideoStats[sessionId]) {
    publisherVideoStats[sessionId] = {
      publisherVideoDisabledDueToQuality: 0,
      publisherVideoDisabledWarningDueToQuality: 0,
    };
  }
  return publisherVideoStats[sessionId] as PublisherVideoStats;
};

media.on([MediaEventType.MediaAudioFallbackEnabled], () => {
  if (session.sessionId) {
    const stats = getOrInitStats(session.sessionId);

    stats.publisherVideoDisabledDueToQuality += 1;
  }
});

media.on([MediaEventType.MediaVideoDisableWarningEnabled], () => {
  if (session.sessionId) {
    const stats = getOrInitStats(session.sessionId);

    stats.publisherVideoDisabledWarningDueToQuality += 1;
  }
});

export function getPublisherVideoStats(
  sessionId?: string,
): PublisherVideoStats {
  if (!sessionId) {
    return {
      publisherVideoDisabledDueToQuality: 0,
      publisherVideoDisabledWarningDueToQuality: 0,
    };
  }

  return getOrInitStats(sessionId);
}
